import React from "react";
// styles
import styles from "./signUp.module.css";
import { PrimaryButton } from "../../buttons/buttons";
import TermsOfService from "../termsOfService/termsOfService";
const CustomTOS = ({
  orgId,
  verify,
  disableSubmit,
  horizontal,
  loadPolicies,
  darkOverlay,
}) => {
  return (
    <>
      <div className={styles.customDisclaimer}>
        <h4>TERMS AND CONDITIONS</h4>
        <p>
          {orgId == 1074
            ? "By registering, you acknowledge and agree to the following terms and conditions listed below. This registration includes a 30-day free trial. Upon trial completion, continued membership requires a monthly subscription of $7.99."
            : orgId == 1034
            ? "By completing this registration form, you agree to be added to the Johnson Fitness & Wellness and Treo Wellness marketing and promotional email lists, as well as the terms and conditions below. You may receive updates on new products, special offers, and wellness tips. You can unsubscribe at any time using the link provided in our emails."
            : orgId == 1114
            ? "By completing this registration form, you agree to be added to the Vision Fitness and Treo Wellness marketing and promotional email lists, as well as the terms and conditions below. You may receive updates on new products, special offers, and wellness tips. You can unsubscribe at any time using the link provided in our emails."
            : "By completing this registration form, you agree to be added to the Matrix Home Fitness and Treo Wellness marketing and promotional email lists, as well as the terms and conditions below. You may receive updates on new products, special offers, and wellness tips. You can unsubscribe at any time using the link provided in our emails."}
        </p>
      </div>

      <div className={styles.customOrgSubmitContainer}>
        <PrimaryButton
       className={styles.createAccountButton}
          onClick={verify}
          disabled={disableSubmit}
        >
          Create My Account
        </PrimaryButton>
      </div>
      <div className={styles.footer}>
        <p>
          <strong>Need help? </strong>
          <a href="mailto:support@treowellness.com">support@treowellness.com</a>
        </p>
      </div>

      <div className={styles.customTermsLink}>
        <TermsOfService
          horizontal={horizontal}
          loadPolicies={loadPolicies}
          darkOverlay={darkOverlay}
        />
      </div>
    </>
  );
};

export default CustomTOS;
